import React from 'react';

import './placeholder.css';

export default ({text, style}) => (
    <div className='placeholder-no-content' style={{ ...style}}  title={text} >   
        <i className='icon-alert-placeholder' />       
        <span> { text } </span>
    </div>
);